// extracted by mini-css-extract-plugin
export var SLVConversationViewSenderImageOff = "BeA01";
export var SLVConversationViewSenderImageOn = "V2uYM";
export var SLVItemViewSenderImageOff = "yPKLI";
export var SLVItemViewSenderImageOn = "VS1hH";
export var bulkActionBarPaddingRuleProgress = "jrx7Y";
export var buttonChecked = "aFHvi";
export var checkBox = "vQae6";
export var checkBoxSingleLine = "ccbWZ";
export var checkBoxThreeColumn = "vDvDy";
export var checkboxSpaceReserved = "MtQpS";
export var compact = "QdRvf";
export var compactDenseless = "M1VK3";
export var conversationViewMCL = "tw_u9";
export var copilotResultsTabVisible = "o8z4B";
export var full = "rf8FT";
export var fullDenseless = "lc4HO";
export var headerIconContainer = "p4pwT";
export var headerIconContainerBleedThrough = "_9luEK";
export var headerIconContainerFull = "bZBXb";
export var headerIconContainerMediumOrCompact = "s27eJ";
export var listViewHasItems = "rk2CU";
export var mailListFirstRow = "Xa56S";
export var mailListHeaderContainer = "bkYAr";
export var mailListHeaderContainerBleedThrough = "jyd7u";
export var mailListSecondRow = "rEzfP";
export var mailListSecondRowCompact = "Xf2QW";
export var mailListSecondRowCustomContainer = "z8J_3";
export var mailListSecondRowDenseless = "mmVwx";
export var mailListSecondRowInnerContent = "_EhYJ";
export var mailListSecondRowInnerContentSearchTable = "fcAA5";
export var mailListSecondRowInterplayEnabled = "VkrBw";
export var mailListSecondRowLeftEntity = "JV_Om";
export var mailListSecondRowSemiCompact = "Q08fq";
export var mailListThirdRowMCL = "Nu9yt";
export var mailListThirdRowSCL = "c57xl";
export var mailSearchSecondRowDenseless = "JBLaR";
export var mcl = "uNaZF";
export var medium = "sInYK";
export var mediumDenseless = "rkZK3";
export var mlHeaderButtonsCompact = "WxMrr";
export var mlHeaderButtonsFull = "GNo52";
export var mlHeaderButtonsSemiCompact = "BIXVu";
export var monTypeRampStyles = "txoLL";
export var noInboxPivots = "m74HI";
export var notesHeaderSecondRow = "F3Yx_";
export var pivotOffset = "EHnMK";
export var scl = "gkKwQ";
export var searchPivotOffset = "mWWR2";
export var secondHeaderActionContainer = "M4U3v";
export var secondRowCustomContainer = "FVCRn";
export var selectAllCheckboxButton = "G9d_n";
export var selectAllCheckboxButtonCompact = "H94YV";
export var selectAllCheckboxButtonMedium = "zdker";
export var selectAllCheckboxButtonWithLabel = "VAqtF";
export var selectAllCheckboxContainerSearchTable = "rnJ_c";
export var selectAllHeaderStyle = "HF7j0";
export var selectAllIconFull = "l2BVB";
export var selectAllIconMediumAndCompact = "xX_ks";
export var selectLabelSingleLine = "Nugcg";
export var senderImageOff = "SC0Zd";
export var senderImageOn = "Gj2Pr";
export var showCheckbox = "tMqIN";
export var showInboxPivots = "i5TJa";
export var singleLineCheckboxButton = "ac0xq";
export var stickyNotesHeaderPadding = "pB18x";
export var thirdrowPaddingBottom = "lV7Ac";
export var threeColConversationViewSenderImageOff = "oSNO0";
export var threeColConversationViewSenderImageOn = "abF91";
export var threeColItemViewSenderImageOff = "jomXP";
export var threeColItemViewSenderImageOn = "dq6vK";
export var withFirstRow = "e2Pgo";